import React from "react";
import { Stack, Typography } from "@mui/material";
import {useHistory} from "react-router-dom";
import {getRouteUrl} from "../../../../helpers/routing/getRouteUrl";

const FooterMenuColumn = ({ title, items, onItemClick,history }) => (
  <Stack sx={{ minWidth: 0 }}>
    <Typography
      variant="overline"
      sx={(theme) => ({
        color: theme.palette.primary.main,
        fontWeight: 700,
        fontSize: 14,
        letterSpacing: "0.1em",
        fontFamily: "'Roboto Condensed', Arial, sans-serif",
        mb: 1.5,
      })}
    >
      {title}
    </Typography>
    <Stack spacing={0.125}>
      {items.map((item) => {
        const label = typeof item === "string" ? item : item.title;
        return (
          <Typography
            key={label}
            variant="body2"
            sx={{
              fontSize: 14,
              fontWeight: 500,
              lineHeight: "120%",
              color: "#111111",
              cursor: "pointer",
              fontFamily: "'Zen Maru Gothic', Arial, sans-serif",
              "&:hover": { textDecoration: "underline" },
            }}
            onClick={() => history.push(getRouteUrl(item.page)) }
          >
            {label}
          </Typography>
        );
      })}
    </Stack>
  </Stack>
);

export default FooterMenuColumn;
